import { Input } from '@wix/design-system';
import React__default, { useContext, useState } from 'react';
import { RicosContext } from 'ricos-context';
import { isValidUrl } from './utils.js';
import 'wix-rich-content-common';

const LinkInput = ({ value, onChange, placeholder, dataHook }) => {
  const { t } = useContext(RicosContext);
  const [url, setUrl] = useState(value);
  const handleInputChange = (event) => {
    const value2 = event.target.value;
    setUrl(value2);
    if (value2 === "" || isValidUrl(value2)) {
      onChange(value2 || void 0);
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    Input,
    {
      type: "url",
      status: url && !isValidUrl(url) ? "error" : void 0,
      statusMessage: url && !isValidUrl(url) ? t("LinkPanel_ErrorTooltip") : void 0,
      placeholder,
      value: url,
      onChange: handleInputChange,
      dataHook
    }
  );
};

export { LinkInput };
//# sourceMappingURL=link-input.js.map
